export default function DemographicsIcon() {
  return (
    <svg
      width="26"
      height="31"
      viewBox="0 0 32 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.25 15.4342C31.25 23.5188 24.448 30.1184 16 30.1184C7.55198 30.1184 0.75 23.5188 0.75 15.4342C0.75 7.34955 7.55198 0.75 16 0.75C24.448 0.75 31.25 7.34955 31.25 15.4342Z"
        stroke="black"
        stroke-width="1.5"
      />
      <path
        d="M1 17.3628C2.02451 17.7535 3.19185 18.0961 4.09943 18.7063C4.90658 19.2489 5.45211 20.1131 5.92689 20.9273C6.33826 21.6327 6.7069 22.4428 7.23106 23.0784C7.71952 23.6707 8.39547 24.0682 9.0867 24.3908C9.73965 24.6956 10.4122 25.1841 10.9262 25.6799C11.1295 25.876 11.4412 26.0653 11.5783 26.309C11.7068 26.5373 11.761 26.7753 11.8681 27.0079C12.0048 27.3046 12.158 27.8371 12.158 28.1611C12.158 28.36 12.0445 29.2565 12.158 29.4207"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M0.861328 14.1925C1.87591 14.0881 2.87856 13.9414 3.75547 13.3849C4.7687 12.7418 5.5712 11.8857 6.4242 11.0629C6.88022 10.623 7.3913 10.2023 7.80083 9.71942C8.18463 9.26692 8.60748 8.82976 9.12111 8.51573C9.88282 8.05003 10.5179 7.49149 10.9888 6.74513C11.9806 5.17347 12.1642 3.25926 12.1642 1.47217"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M15.7142 1.12256C15.6221 1.97126 15.4533 2.86108 15.5129 3.71633C15.5661 4.47861 15.839 5.09647 16.2294 5.74708C16.8892 6.84641 17.6537 7.87991 18.3145 8.97764C18.7639 9.72415 18.9979 10.661 19.6147 11.3035C20.448 12.1717 21.4742 12.7341 22.6658 12.9692C24.6054 13.352 26.563 13.3537 28.5386 13.3537C29.3389 13.3537 31.7299 13.144 30.9296 13.144"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M13.5001 15.4339C11.9001 16.5914 12.8335 18.8101 13.5001 19.7747C13.7934 20.2571 16.5 23.6333 17 24.5979C17.5 25.5626 20 27.4918 22 27.0095C24 26.5272 24 24.5979 24.5 23.151C25 21.704 26 22.1863 27 19.2924C28 16.3985 23.5 16.8808 22 16.8808C20.5 16.8808 19 15.4339 18 14.9516C17 14.4692 15.5001 13.9869 13.5001 15.4339Z"
        stroke="black"
        stroke-width="1.5"
      />
    </svg>
  );
}
